
export default {
  props: {
    buttonLoad: Boolean,
    actionSend: {
      type: Function,
      default: () => {},
    },
    value: {
      type: Object,
      default() {
        return {
          nome: '',
          phoneNumber: '',
          document: '',
        }
      },
    },
  },
}
